var map = {
	"./1.png": 193,
	"./1_.png": 194,
	"./2.png": 195,
	"./2_.png": 196,
	"./3.png": 197,
	"./3_.png": 198,
	"./4.png": 92,
	"./4_.png": 199,
	"./5.png": 93,
	"./5_.png": 200
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 192;